import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ColorsTable.vue"),
          meta: { title: "Список цветов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/ColorsForm.vue"),
          meta: { title: "Создать цвет", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ColorsForm.vue"),
          meta: { title: "Редактировать цвет", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
